import PropsTypes from "prop-types";
import { memo } from "react";

const Backdrop = (props) => {
  return (
    <div
      className={
        `inset-0 absolute bg-primary z-40 ` +
        (props.block ? "" : "bg-opacity-50")
      }
    />
  );
};

Backdrop.propType = {
  block: PropsTypes.bool,
};

export default memo(Backdrop);
